import { apiWrapper } from "apis/CommonApi";
import Pagenation from "components/Pagenation";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "utils/store";
import * as fireonApi from "../../apis/FireOnApi";
import { getDateTime } from "utils/date";
import { useReactToPrint } from "react-to-print";
import FireOnToolbar from "./FireOnToolbar";

export default function SMSHistoryListComponent(props) {
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    return (
        <>
            <div className="viewBoard fireOnBoard tableBoard shlTableBoard fahBoard">
                <TopBoard currentDateTime={props.currentDateTime} />
                <MidBoard />
                <FireOnToolbar item="SMS 전송이력" buildingName={buildingName} serialNumber={serialNumber} dei={dei} />
            </div>
        </>
    );
}

const TopBoard = ({ currentDateTime }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { store: { userName } } = useAppContext();
    const location = useLocation();

    const handleGoBack = () => {
        navigate(`/fire-on/alarm-monitor/${id}`, location.state);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo" /> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <a className="set_contr" href="#">
                            <img src="/images/my_btn_mb_w.png" alt="" />
                        </a>
                    </div>
                </div>
            </div>

            <div class="top_board navi_board">
                <div class="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p class="title_navi">SMS 전송이력</p>
                </div>
                <div className="wrap_right pc">
                    <div className="wrap_userBox">
                        <div className="wrap_userInfo pc">
                            <p className="current_date">{currentDateTime}</p>
                        </div>
                        <p className="user_id">{userName}</p>
                    </div>
                </div>
                <div class="wrap_right mb">
                    <a class="btn_page_left" href="/smsHistoryList_mb.html">
                        <i class="x-icon"></i>
                    </a>
                </div>
            </div>
        </>
    );
};

const MidBoard = () => {
    const { id } = useParams();
    const location = useLocation();
    const { buildingName } = location.state;
    const itemsPerPage = 100;
    const [dataSource, setDataSource] = useState([]);
    const [previous, setPrevious] = useState(null);
    const [next, setNext] = useState(null);
    const [page, setPage] = useState(1);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [searchText, setSearchText] = useState("");
    const printRef = useRef();

    useEffect(() => {
        getData(1);
    }, []);

    //page: 1베이스
    const getData = (page, url = null) => {
        apiWrapper(async () => {
            let result;
            if (url !== null) {
                result = await fireonApi.getFireAlarmSmsHistoryListByUrl(url);
            } else {
                result = await fireonApi.getFireAlarmSmsHistoryList(
                    id,
                    startDate,
                    endDate,
                    searchText,
                    page,
                    itemsPerPage
                );
            }

            const { status, data } = result;
            if (status === true) {
                setDataSource(data);

                setPrevious(data.previous);
                setNext(data.next);
                setPage(page);
            } else {
                alert(`${data}`);
            }
        });
    };

    const handlePageArrowClick = (page, isNext) => {
        let url = null;
        if (isNext === false) {
            url = previous;
        } else {
            url = next;
        }

        getData(page, url);
    }

    const handleChangeSearchText = (e) => {
        setSearchText(e.target.value);
    }

    const handleSearch = (e) => {
        if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
            getData(page);
        }
    }

    const handleExportExcel = () => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.downloadExcelFireAlarmSmsHistoryList(id);
            if (status === false) {
                alert(`엑셀 저장에 실패하였습니다.\n${data}`);
            }
        });
    }

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: "SMS 전송이력",
    });

    return (
        <>
            <div class="mid_board mid_col_board">
                <div class="wrap_mid_le">
                    <p class="title_mid">{buildingName}</p>
                </div>
                <div class="wrap_right pc">
                    <div class="wrap_item_contr mid_input_container">
                        <div class="wrap_detail_item ">
                            <div class="detail_box detail_date_box open">
                                <div className={`date-input-wrap ${startDate ? "selected" : ""}`} onChange={(e) => setStartDate(e.target.value)}>
                                    <p class="date_all_title">전송기간</p>
                                    <input type="date" class="form-input" id="start_date" value={startDate} required="required" />
                                    <p class="date-title has-value" style={{ display: startDate ? "block" : "none" }}>{startDate.replace(/-/g, '.')}</p>
                                </div>
                                <span class="divi-col">-</span>
                                <div className={`date-input-wrap ${endDate ? "selected" : ""}`} onChange={(e) => setEndDate(e.target.value)}>
                                    <input type="date" class="form-input" id="end_date" value={endDate} required="required" />
                                    <p class="date-title right-title has-value" style={{ display: endDate ? "block" : "none" }}>{endDate.replace(/-/g, '.')}</p>
                                </div>
                            </div>
                            <div class="wrap_search openSearch">
                                <div class="box_search">
                                    <input class="" type="text" placeholder="검색어를 입력해주세요." onChange={handleChangeSearchText} onKeyDown={handleSearch} defaultValue={searchText} />
                                    <button class="btn_search" onClick={handleSearch}>
                                        <i class="x-icon icon_search"></i>
                                    </button>
                                    <p class="input-title">수신자</p>
                                </div>
                            </div>
                        </div>
                        <div class="wrap_item_contr">
                            <button class="btn_contr btn_add" onClick={handleExportExcel}>
                                엑셀
                            </button>
                            <button class="btn_contr btn_del" onClick={handlePrint}>
                                인쇄
                            </button>
                        </div>
                    </div>
                </div>
            </div >
            <TableBoard printRef={printRef} dataSource={dataSource} />

            <div class="wrap_controll type-start type-black">
                <div id="pagination">
                    <Pagenation
                        totalItemsCount={dataSource.count}
                        itemsPerPage={itemsPerPage}
                        selectedPage={page}
                        setPage={(value) => setPage(value)}
                        handlePageArrowClick={handlePageArrowClick}
                    />
                </div>
            </div>
        </>
    );
};

const TableBoard = ({ printRef, dataSource }) => {
    return (
        <div ref={printRef} class="table_board scroll_board shl_table_board">
            <div class="wrap_table">
                <div class="containerTable smsHistoryTable">
                    <ul class="head_table">
                        <li>
                            <p>전송일시</p>
                        </li>
                        <li>
                            <p>수신자</p>
                        </li>
                        <li>
                            <p>연락처</p>
                        </li>
                        <li>
                            <p>전송내용</p>
                        </li>
                        <li>
                            <p>수신 확인일시</p>
                        </li>
                    </ul>
                    <div class="body_table">
                        <div class="inner_table_wrap">
                            {dataSource.results &&
                                dataSource.results.map((item) => (
                                    <div class="wrap_table_item">

                                        <div class="inner_table_item table_item_01">
                                            <p class="cont_table_item">
                                                {getDateTime(new Date(item.eventTime))}
                                            </p>
                                        </div>

                                        <div class="inner_table_item table_item_02">
                                            <p class="cont_table_item">
                                                {item.receiver}
                                            </p>
                                        </div>

                                        <div class="inner_table_item table_item_03">
                                            <p class="cont_table_item">
                                                {item.contact}
                                            </p>
                                        </div>

                                        <div class="inner_table_item table_item_04">
                                            <p class="cont_table_item">
                                                {item.description}
                                            </p>
                                        </div>

                                        <div class="inner_table_item table_item_05">
                                            <p class="cont_table_item">
                                                {item.confirmedAt ? getDateTime(new Date(item.confirmedAt)) : null}
                                            </p>
                                        </div>

                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}